<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <div id="reset-wrapper"><a href="/"><img src="../assets/images/icons/home.png" class="full-logo"></a></div>

    <div class="l-container l-pad">
      <img src="../assets/images/logos/ucas_logo.svg"  class="ucas-logo hidden" />
      <img src="../assets/images/logos/logo__unite.png"  class="unite-logo hidden" />
      <h4>From your answers, you're most like:</h4>
      <h2>{{student.name | capitalize}}</h2>
      <p class="l--result">{{student.result}}</p>
      <p class="leapskills">Thank you for taking part in Leapskills. Make sure to check out The <a href="https://www.unitestudents.com/the-common-room" target="_blank"><strong>Common Room</strong></a> where you will find lots of advice and information about student life from making friends and budgeting to staying healthy.</p>
      <img :src='student.image' class="l--right">
      <div id="reset-wrapper"><a href="/"><div class="m-btn m-btn__primary m-btn--left">Start Again!</div></a></div>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Brand from '../components/Brand'
import MainFooter from '../components/MainFooter'

export default {
  created () {
    // this.storeResponsesInFirebase()
  },
  computed: {
    ...mapGetters(['getScore', 'getStudentByName']),
    highScore () {
      let scoreArray = this.getScore
      var res = Math.max.apply(Math, scoreArray.map(function (o) { return o.score }))
      var obj = scoreArray.find(function (o) { return o.score === res })
      return obj
    },
    student () {
      let student = this.highScore.name
      return this.getStudentByName(student)
    }
  },
  methods: {
    // ...mapActions(['storeResponsesInFirebase'])
  },
  components: {
    Brand,
    MainFooter
  },
  name: 'Result'
}
</script>

<style scoped lang='scss'>

.hidden {
  display: none;
}

img.l--right {
  margin-right: 35px;
  width: 37%;
}
.unite-logo {
  width:150px;
}

.ucas-logo  {
  width:150px;
  float:left;
  margin-right: 60px;
}
p.leapskills {display:none;}
p.leapskills a {color:#000;text-decoration:underline;}
h2 {margin-bottom:10px;}
h4 {margin-top: 20px;}
@media (max-width: 899px) {
    h4  {font-size:125%;margin:0;}
    h2 {font-size:190%;}
    p {font-size:70%;width:70%;margin-bottom:25px;}
    img.l--right {margin-right:60px;width:22%;}
    p.leapskills {margin:0;font-size:60%;}
  }

</style>



// WEBPACK FOOTER //
// src/views/Result.vue